<template>
  <div
    class="search-container"
    :class="`${isUserLogged ? 'logged' : 'not-logged'}`"
  >
    <div
      class="search-button"
      :class="isUserLogged ? 'logged' : 'not-logged'"
      v-if="width > 1100 && !showSearchInput"
    >
      <ElButton
        :type="
          isScrolled || darkBackground
            ? 'icon disabled with-blur lg'
            : lightBackground
            ? 'icon action-selected lg'
            : 'icon tins-dark-1 lg'
        "
        @click="openSearchInput()"
      >
        <Icons
          :name="
            lightBackground || darkBackground || isScrolled
              ? '24px/search'
              : '24px/search_white'
          "
        />
      </ElButton>
    </div>
    <transition name="grow">
      <div
        class="search-input"
        :class="showResults && querySearch ? 'results' : ''"
        v-if="width > 1100 && showSearchInput"
      >
        <ElInput
          ref="searchInputRef"
          class="landing-search"
          :placeholder="$t('where_next')"
          v-model="querySearch"
          :class="
            lightBackground && !isScrolled
              ? 'custom-action-selected'
              : darkBackground || isScrolled || (lightBackground && isScrolled)
              ? 'brand-mid-grey'
              : 'tins-dark-2 with-blur'
          "
          v-loading="loading"
          @input="debounce(() => search())"
          @keydown.enter.prevent="search()"
        >
          <template #suffix>
            <Icons
              :name="
                lightBackground || darkBackground || isScrolled
                  ? '24px/search'
                  : '24px/search_white'
              "
              @click="search()"
            />
          </template>
        </ElInput>
      </div>
    </transition>
    <div
      :class="`search-results ${
        isScrolled || lightBackground || darkBackground ? '' : 'dark'
      }`"
      v-if="showSearchInput && width > 1100"
    >
      <div
        v-if="results?.search?.data?.length && querySearch.length >= 3"
        :class="`results ${
          isScrolled || lightBackground || darkBackground ? '' : 'dark'
        }`"
      >
        <div
          :class="`results-title ${
            isScrolled || lightBackground || darkBackground ? '' : 'dark'
          }`"
          @click="
            router.push(`/search?query=${querySearch}`),
              (showSearchInput = false),
              $emit('showSearch', false)
          "
        >
          <span
            class="body2"
            v-html="$t('see_all_results_for', { query: querySearch })"
          />
          <Icons
            :name="
              isScrolled || lightBackground
                ? '16px/arrow_right'
                : '16px/arrow_right_white'
            "
          />
        </div>
        <div
          :class="`result-item ${
            isScrolled || lightBackground || darkBackground ? '' : 'dark'
          }`"
          v-for="item in galleryItems"
          :key="item.uuid"
          @click="goTo(item)"
        >
          <div class="item-image">
            <img v-if="item.image" :src="item.image" loading="lazy" />
            <img
              v-else
              src="/logos/PALC_Marque_Black.svg"
              alt="logo"
              class="logo-img"
            />
          </div>
          <div class="item-text">
            <div class="item-title">
              <span v-html="getSearchItemFormat(item.name, 'body1')"></span>
            </div>
            <div class="item-description">
              <span
                v-html="
                  `${$t(item.type)} | ${getSearchItemFormat(
                    item.address,
                    'body2'
                  )}, ${$t('countries.' + item.country.toLowerCase())}`
                "
              ></span>
            </div>
          </div>
        </div>
      </div>
      <div
        v-else-if="
          querySearch.length >= 3 && results?.search?.data?.length === 0
        "
        :class="`no-results ${
          isScrolled || lightBackground || darkBackground ? '' : 'dark'
        }`"
      >
        <span class="body1-strong">
          {{ $t('no_results_found_for', { query: querySearch }) }}
        </span>
      </div>
      <div
        v-else
        :class="`suggestions ${
          isScrolled || lightBackground || darkBackground ? '' : 'dark'
        }`"
      >
        <div
          :class="`suggestions-title ${
            isScrolled || lightBackground || darkBackground ? '' : 'dark'
          }`"
        >
          <span class="body2-strong">
            {{ $t('suggestions') }}
          </span>
        </div>
        <div
          :class="`suggestion-item ${
            isScrolled || lightBackground || darkBackground ? '' : 'dark'
          }`"
          v-for="item in suggestions"
          :key="item.uuid"
          @click="goTo(item)"
        >
          <div class="item-image">
            <img v-if="item.image" :src="item.image" loading="lazy" />
            <img
              v-else
              src="/logos/PALC_Marque_Black.svg"
              alt="logo"
              class="logo-img"
            />
          </div>
          <div class="item-text">
            <div class="item-title">
              <span class="body1">{{ item.name }}</span>
            </div>
            <div class="item-description">
              <span class="body2"
                >{{ $t(item.type) }} | {{ item.address }},
                {{ $t('countries.' + item.country.toLowerCase()) }}</span
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-drawer
      v-if="width <= 1100"
      v-model="showResults"
      direction="rtl"
      class="left-drawer"
      :append-to-body="true"
      modal-class="left-drawer-modal"
    >
      <template #header>
        <div class="search-input" v-loading="loading">
          <ElInput
            class="landing-search grey-background"
            :placeholder="$t('where_next')"
            v-model="querySearch"
            @input="debounce(() => search())"
          >
            <template #suffix>
              <Icons name="24px/search" />
            </template>
          </ElInput>
        </div>
      </template>
      <div
        v-if="querySearch && showResults && results?.search?.data?.length"
        class="results"
      >
        <div
          class="results-title"
          @click="
            router.push(`/search?query=${querySearch}`),
              (showResults = false),
              $emit('showResults', false)
          "
        >
          <span
            class="body2"
            v-html="$t('see_all_results_for', { query: querySearch })"
          />
          <Icons name="16px/arrow_right" />
        </div>
        <div
          class="result-item"
          v-for="item in galleryItems"
          :key="item.uuid"
          @click="goTo(item)"
        >
          <div class="item-image">
            <img v-if="item.image" :src="item.image" loading="lazy" />
            <img
              v-else
              src="/logos/PALC_Marque_Black.svg"
              alt="logo"
              class="logo-img"
            />
          </div>
          <div class="item-text">
            <div class="item-title">
              <span v-html="getSearchItemFormat(item.name, 'body1')"></span>
            </div>
            <div class="item-description">
              <span
                v-html="
                  `${$t(item.type)} | ${getSearchItemFormat(
                    item.address,
                    'body2'
                  )} ${$t('countries.' + item.country.toLowerCase())}`
                "
              ></span>
            </div>
          </div>
        </div>
      </div>
      <div
        v-else-if="
          querySearch && showResults && results?.search?.data?.length === 0
        "
        class="no-results"
      >
        <span class="body1-strong">
          {{ $t('no_results_found_for', { query: querySearch }) }}
        </span>
      </div>
      <div v-else class="suggestions">
        <div class="suggestions-title">
          <span class="body2-strong">
            {{ $t('suggestions') }}
          </span>
        </div>
        <div
          class="suggestion-item"
          v-for="item in suggestions"
          :key="item.uuid"
          @click="goTo(item)"
        >
          <div class="item-image">
            <img v-if="item.image" :src="item.image" loading="lazy" />
            <img
              v-else
              src="/logos/PALC_Marque_Black.svg"
              alt="logo"
              class="logo-img"
            />
          </div>
          <div class="item-text">
            <div class="item-title">
              <span class="body1">{{ item.name }}</span>
            </div>
            <div class="item-description">
              <span class="body2"
                >{{ $t(item.type) }} | {{ item.address }},
                {{ $t('countries.' + item.country.toLowerCase()) }}</span
              >
            </div>
          </div>
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
export default defineComponent({
  setup() {
    const route = useRoute()
    const router = useRouter()
    const config = useRuntimeConfig()
    const { $eventBus } = useNuxtApp()
    const { width, height } = useBreakpoints()
    const { debounce } = getTableInitialVariables()

    return {
      $eventBus,
      route,
      router,
      width,
      debounce,
      config
    }
  },
  props: {
    lightBackground: {
      type: Boolean,
      default: false
    },
    isScrolled: {
      type: Boolean,
      default: false
    },
    darkBackground: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loading: false,
      querySearch: '',
      results: null,
      showResults: false,
      showAccommodations: false,
      showExperiences: false,
      showRestaurants: false,
      showActivities: false,
      showTours: false,
      showSearchInput: false
    }
  },
  watch: {
    showResults(newVal) {
      this.$emit('showResults', newVal)
    },
    showSearchInput(newVal) {
      this.$eventBus.$emit('showSearchInput', newVal)
    },
    'route.fullPath'(newVal) {
      this.querySearch = ''
      this.showResults = false
    }
  },
  computed: {
    galleryItems() {
      return this.results?.search?.data?.slice(0, 3) ?? []
    },
    isUserLogged() {
      return getAuthUser()?.value?.uuid ? true : false
    },
    suggestions() {
      if (this.config.public.environment === 'production') {
        return [
          {
            uuid: '980ca664-193c-43be-a95f-6a5b0497072d',
            slug: 'malaga-gold-sky-sea-luxury-journey',
            name: 'Málaga Gold: Sky & Sea Luxury Journey',
            type: 'experience',
            address: 'Málaga',
            country: 'Spain',
            image:
              'https://api.paradisealacarte.com/file/723b139e-4145-49df-8754-0f6b99f0ebb9'
          },
          {
            uuid: '91ab571a-6a53-4ec3-8f03-c0191a676cc8',
            slug: 'can-concordia',
            name: 'Can Concordia',
            type: 'accommodation',
            address: 'Ibiza',
            country: 'Spain',
            image:
              'https://api.paradisealacarte.com/file/5289a887-7651-497a-b6b4-bc841a290123'
          },
          {
            uuid: '3ed71b59-b949-4510-9264-e5b8d9e2e365',
            slug: 'disfrutar',
            name: 'Disfrutar',
            type: 'restaurant',
            address: 'Barcelona',
            country: 'Spain',
            image:
              'https://api.paradisealacarte.com/file/fd765641-5339-4664-944d-56315156fdd8'
          }
        ]
      }
      return [
        {
          uuid: '3f138f9c-3619-4379-bf3b-d7c86e1dbae6',
          slug: 'barcelona-luxury-essence-gastronomic-cultural-immersion',
          name: 'Football Legends: El Clásico VIP Immersion',
          type: 'experience',
          address: 'Barcelona',
          country: 'Spain',
          image:
            'https://api-beta.paradisealacarte.com/file/856add75-5176-4399-81a4-d2e412616051'
        },
        {
          uuid: '23ab6dc6-d123-4dc7-be19-caa6d91c318f',
          slug: 'alpine-haven',
          name: 'Alpine Haven',
          type: 'accommodation',
          address: 'Auvergne-Rhône-Alpes',
          country: 'France',
          image:
            'https://api-beta.paradisealacarte.com/file/5311a115-765e-481d-8b05-1d9726e6b44e'
        },
        {
          uuid: 'eaf1845c-706e-4fde-9a5d-db5c259bcfbf',
          slug: 'disfrutar',
          name: 'Disfrutar',
          type: 'restaurant',
          address: 'Barcelona',
          country: 'Spain',
          image:
            'https://api-beta.paradisealacarte.com/file/9aada045-5b34-4e8f-82cd-6a95afb5a40b'
        }
      ]
    }
  },
  mounted() {
    this.$eventBus.$on('closeSearch', () => {
      this.showResults = false
      this.showSearchInput = false
      this.querySearch = ''
    })
  },
  methods: {
    async search(refetch = false) {
      if (this.querySearch?.length >= 3) {
        try {
          this.loading = true
          this.results = await apolloSearch(
            {
              search: this.querySearch,
              first: 50
            },
            false,
            {},
            refetch ? 'network-only' : null
          )
          this.showResults = true
          if (this.results?.search?.data?.length) {
            this.showExperiences = this.results.search.data.find(
              (i) => i.type === 'experience'
            )
              ? true
              : false
            this.showActivities = this.results.search.data.find(
              (i) => i.type === 'activity'
            )
              ? true
              : false
            this.showAccommodations = this.results.search.data.find(
              (i) => i.type === 'accommodation'
            )
              ? true
              : false
            this.showRestaurants = this.results.search.data.find(
              (i) => i.type === 'restaurant'
            )
              ? true
              : false
            this.showTours = this.results.search.data.find(
              (i) => i.type === 'tour'
            )
              ? true
              : false
          }
        } catch (err) {
          this.$showError(err, this.t)
          this.$sentry(err, 'search')
        } finally {
          this.loading = false
        }
      } else if (this.querySearch?.length < 3) {
        this.showResults = true
        this.results = null
      } else {
        this.showResults = false
      }
    },
    getSearchItemFormat(string, className) {
      if (string) {
        let result = `<span class="${className}">${string}</span>`

        const searchRegex = new RegExp(this.querySearch, 'gi')

        function preserveCase(match) {
          return `<span class="${className}-strong">${match}</span>`
        }

        return result.replace(searchRegex, preserveCase)
      }
      return '-'
    },
    goTo(item) {
      if (item.type === 'experience') {
        this.router.push(`/experiences/${item.slug || item.uuid}`)
      } else if (item.type === 'activity') {
        this.router.push(`/activities/${item.slug || item.uuid}`)
      } else if (item.type === 'accommodation') {
        this.router.push(`/accommodations/${item.slug || item.uuid}`)
      } else if (item.type === 'restaurant') {
        this.router.push(`/restaurants/${item.slug || item.uuid}`)
      }
      this.showSearchInput = false
      this.$emit('showSearchInput', false)
      this.showResults = false
    },
    openSearchInput() {
      this.showSearchInput = true
      this.$emit('showSearchInput', true)
      setTimeout(() => {
        if (this.$refs.searchInputRef) {
          this.$refs.searchInputRef.focus()
        }
      }, 300)
    }
  }
})
</script>

<style scoped lang="scss">
.search-container {
  position: absolute;
  top: 14px;
  &.not-logged {
    @media (min-width: 1100px) {
      width: 550px;
      right: calc(24px + 50px + 96px + 50px + 24px);
    }
  }
  &.logged {
    @media (min-width: 1100px) {
      width: 550px;
      right: calc(24px + 50px + 96px + 50px + 50px);
    }
  }
  .search-button {
    position: absolute;
    @media (min-width: 1100px) {
      top: -4px;
      right: -18px;
    }
    display: flex;
    align-items: center;
    &.not-logged {
      @media (min-width: 1100px) {
        right: -18px;
      }
    }
  }
  .search-input {
    position: relative;
    right: -18px;
    top: -4px;
    transform-origin: right center;
    .landing-search {
      height: 48px !important;
      :deep(.el-input__wrapper) {
        height: 48px !important;
        input {
          height: 48px !important;
        }
        .el-input__suffix {
          cursor: default !important;
          .el-input__suffix-inner {
            width: 0;
            i {
              position: relative;
              left: -20px;
            }
          }
        }
      }
    }
  }

  .search-results {
    border-radius: 23px;
    background: var(--brand-white);
    &.dark {
      background-color: var(--tins-dark-1);
      backdrop-filter: blur(5px);
    }
    width: 100%;
    overflow-y: auto;
    position: relative;
    left: 20px;
    top: 10px;
    padding: 24px;

    .results {
      overflow-y: auto;
      max-height: 80vh;
      .results-title {
        cursor: pointer;
        margin-bottom: 16px;
        width: 100%;
        text-align: right;
        &.dark {
          color: var(--brand-white);
        }
        i {
          display: inline-block;
          margin-left: 4px;
        }
        .body2 {
          display: inline-block;
        }
      }
      .result-item {
        cursor: pointer;
        &:not(:last-of-type) {
          margin-bottom: 8px;
        }
        &.dark {
          color: var(--brand-white);
        }
        .item-image {
          width: 80px;
          height: 80px;
          border-radius: 3px;
          background-color: var(--brand-off-white);
          display: inline-flex;
          align-items: center;
          justify-content: center;
          img {
            object-fit: cover;
            border-radius: 3px;
            width: 100%;
            height: 100%;
            &.logo-img {
              height: 32px !important;
              width: 32px !important;
              object-fit: contain !important;
            }
          }
        }

        .item-text {
          margin-left: 16px;
          display: inline-flex;
          align-items: flex-start;
          justify-content: center;
          height: 80px;
          vertical-align: top;
          flex-direction: column;
          width: calc(100% - 80px - 16px);
        }
      }
    }

    .no-results {
      &.dark {
        color: var(--brand-white);
      }
      .no-results-actions {
        width: 100%;
        padding: 8px 0 8px 0;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }

    .suggestions {
      .suggestions-title {
        margin-bottom: 16px;
        &.dark {
          color: var(--brand-white);
        }
      }
      .suggestion-item {
        cursor: pointer;
        &:not(:last-of-type) {
          margin-bottom: 8px;
        }
        &.dark {
          color: var(--brand-white);
        }
        .item-image {
          width: 80px;
          height: 80px;
          border-radius: 3px;
          background-color: var(--brand-off-white);
          display: inline-flex;
          align-items: center;
          justify-content: center;
          img {
            object-fit: cover;
            border-radius: 3px;
            width: 100%;
            height: 100%;
            &.logo-img {
              height: 32px !important;
              width: 32px !important;
              object-fit: contain !important;
            }
          }
        }

        .item-text {
          margin-left: 16px;
          display: inline-flex;
          align-items: flex-start;
          justify-content: center;
          height: 80px;
          gap: 4px;
          vertical-align: top;
          flex-direction: column;
          width: calc(100% - 80px - 16px);
        }
      }
    }
  }
}

.left-drawer-modal {
  .el-drawer__header {
    .search-input {
      margin-right: 8px;
    }
  }
  .el-drawer__body {
    .results {
      .results-title {
        cursor: pointer;
        margin-bottom: 16px;
        width: 100%;
        text-align: right;
        &.dark {
          color: var(--brand-white);
        }
        i {
          display: inline-block;
          margin-left: 4px;
          position: relative;
          top: 4px;
        }
        .body2 {
          display: inline-block;
        }
      }
      .result-item {
        cursor: pointer;
        &:not(:last-of-type) {
          margin-bottom: 8px;
        }
        .item-image {
          width: 80px;
          height: 80px;
          border-radius: 3px;
          background-color: var(--brand-off-white);
          display: inline-flex;
          align-items: center;
          justify-content: center;
          img {
            object-fit: cover;
            border-radius: 3px;
            width: 100%;
            height: 100%;
            &.logo-img {
              height: 32px !important;
              width: 32px !important;
              object-fit: contain !important;
            }
          }
        }

        .item-text {
          margin-left: 16px;
          display: inline-flex;
          align-items: flex-start;
          justify-content: center;
          height: 80px;
          vertical-align: top;
          flex-direction: column;
          max-width: calc(100% - 96px);
        }
      }
    }

    .no-results {
      .no-results-actions {
        width: 100%;
        padding: 24px 0 8px 0;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }

    .suggestions {
      .suggestions-title {
        margin-bottom: 16px;
      }
      .suggestion-item {
        cursor: pointer;
        &:not(:last-of-type) {
          margin-bottom: 8px;
        }
        .item-image {
          width: 80px;
          height: 80px;
          border-radius: 3px;
          background-color: var(--brand-off-white);
          display: inline-flex;
          align-items: center;
          justify-content: center;
          img {
            object-fit: cover;
            border-radius: 3px;
            width: 100%;
            height: 100%;
            &.logo-img {
              height: 32px !important;
              width: 32px !important;
              object-fit: contain !important;
            }
          }
        }

        .item-text {
          margin-left: 16px;
          display: inline-flex;
          align-items: flex-start;
          justify-content: center;
          height: 80px;
          vertical-align: top;
          flex-direction: column;
          max-width: calc(100% - 96px);
        }
      }
    }
  }
}

/* Transición */
.grow-enter-active,
.grow-leave-active {
  transition: transform 0.4s ease, opacity 0.4s ease;
}

/* Cuando aparece */
.grow-enter-from {
  transform: scaleX(0);
  opacity: 0;
}
.grow-enter-to {
  transform: scaleX(1);
  opacity: 1;
}

/* Cuando desaparece */
.grow-leave-from {
  transform: scaleX(1);
  opacity: 1;
}
.grow-leave-to {
  transform: scaleX(0);
  opacity: 0;
  transform-origin: left center; /* <-- Cambia el punto de contracción */
}
</style>